import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RobotHappyOutlineIcon from 'mdi-react/RobotHappyOutlineIcon';
import CloseIcon from 'mdi-react/CloseIcon';
import PencilIcon from 'mdi-react/PencilIcon';
import RefreshIcon from 'mdi-react/RefreshIcon';
import {
  limitlessAiSetTrayOpen, limitlessAiSetDisplayName, limitlessAiResetDisplayName,
} from '../../../../redux/actions/limitlessAiActions';
import LimitlessAiChat from './LimitlessAiChat';

const LimitlessAiTray = () => {
  const dispatch = useDispatch();
  const limitlessAi = useSelector(store => store.limitlessAi);
  const user = useSelector(store => store.authentication.user);
  const { active, trayOpen, displayName } = limitlessAi;

  const [isEditingName, setIsEditingName] = useState(false);
  const [nameDraft, setNameDraft] = useState(displayName);

  // TEMPORARY: Limitless AI is restricted to admin users only while it's under active
  // development/testing. Remove this check once ready for a wider rollout.
  const isAdmin = user?.access === 'admin';

  if (!active || !isAdmin) return null;

  const openTray = () => dispatch(limitlessAiSetTrayOpen(true));
  const closeTray = () => dispatch(limitlessAiSetTrayOpen(false));

  const startEditingName = () => {
    setNameDraft(displayName);
    setIsEditingName(true);
  };

  const saveName = () => {
    dispatch(limitlessAiSetDisplayName(nameDraft));
    setIsEditingName(false);
  };

  const handleNameKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      saveName();
    } else if (event.key === 'Escape') {
      setIsEditingName(false);
      setNameDraft(displayName);
    }
  };

  const handleResetName = () => {
    dispatch(limitlessAiResetDisplayName());
    setIsEditingName(false);
  };

  if (!trayOpen) {
    return (
      <button
        type="button"
        className="limitless-ai__tab"
        onClick={openTray}
        aria-label={`Open ${displayName}`}
        title={displayName}
      >
        <RobotHappyOutlineIcon className="limitless-ai__tab-icon" />
      </button>
    );
  }

  return (
    <div className="limitless-ai__tray">
      <div className="limitless-ai__tray-header">
        {isEditingName ? (
          <input
            type="text"
            className="limitless-ai__name-input"
            value={nameDraft}
            onChange={event => setNameDraft(event.target.value)}
            onBlur={saveName}
            onKeyDown={handleNameKeyDown}
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
          />
        ) : (
          <button
            type="button"
            className="limitless-ai__tray-title"
            onClick={startEditingName}
            title="Click to rename"
          >
            <RobotHappyOutlineIcon className="limitless-ai__tray-title-icon" />
            {displayName}
            <PencilIcon className="limitless-ai__rename-icon" />
          </button>
        )}
        {displayName !== 'Limitless AI' && !isEditingName && (
          <button
            type="button"
            className="limitless-ai__reset-name-btn"
            onClick={handleResetName}
            aria-label="Reset name to Limitless AI"
            title="Reset name to Limitless AI"
          >
            <RefreshIcon />
          </button>
        )}
        <button
          type="button"
          className="limitless-ai__close-btn"
          onClick={closeTray}
          aria-label="Close"
        >
          <CloseIcon />
        </button>
      </div>
      <LimitlessAiChat displayName={displayName} />
    </div>
  );
};

export default LimitlessAiTray;
